<template>
  <LangRouterLink
    :to="{ name: 'post.show', params: { slug: `${post.slug}-${post.id}` } }"
    class="card-article"
  >
    <Image v-if="post.image" :source="post.image" class="card-article__image" />
    <div class="card-article__content">
      <h3 class="card-article__subtitle">
        {{ $store.getters.post_category(post.category_id)?.name }} -
        {{ formatDate(post.published_at, $i18n.locale) }}
      </h3>
      <h2 class="card-article__title">{{ post.title }}</h2>
      <p class="card-article__text">{{ post.summary }}</p>
      <LangRouterLink
        :to="{ name: 'post.show', params: { slug: `${post.slug}-${post.id}` } }"
        class="card-article__link"
      >
        <Icon id="arrow" />
        <p>{{ $t('learn_more') }}</p>
      </LangRouterLink>
    </div>
  </LangRouterLink>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import { formatDate } from '@/helpers/dateHelpers.js'

export default {
  name: 'PostCard',
  components: { Image, Icon, LangRouterLink },
  setup: () => ({ formatDate }),
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
}
</script>
